import { useMe } from './useMe'

/**
 * Per-company gate for the entire Inventory (stock) module (PRO-483).
 *
 * Reads the backend-controlled opt-in
 * `CompanySettingsType.inventoryEnabled`, part of the `me` query
 * (`GetMeByProjectIds`, `src/api/auth-queries.ts`). Mirrors
 * `usePhysicalKeysEnabled` / `useHaulerModuleEnabled`.
 *
 * FAIL-SAFE: when the field is missing/undefined (an older backend or a
 * partial cache), the module is treated as OFF. This hook only hides the
 * FE surfaces (nav entry, routes, Settings tabs) — there is no server-side
 * enforcement yet (follow-up), so this is a visibility gate, not a security
 * boundary.
 */
export const useInventoryEnabled = (): boolean =>
  Boolean(useMe()?.company?.companySettings?.inventoryEnabled)
